/* import __COLOCATED_TEMPLATE__ from './user-summary-section.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./user-summary-section.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  classNames: ["top-sub-section"]
}));